export default class RetryCounter {
  private static readonly limit: number = 3;
  private counter: number;

  constructor() {
    this.counter = 0;

  }

  public isLimit(): boolean {
    return this.counter === RetryCounter.limit;
  }

  public countUp(): void {
    this.counter++;
  }

  public reset(): void {
    this.counter = 0;
  }
}
